import { observable, runInAction } from "mobx";
import { RootStore } from "./stores";
import { TodoModel } from "../models";
import { BaseStore } from "./base";
import {
    RequestRouteTodoGet,
    ParamsRouteTodoGet,
    ResponseRouteTodoGet,
    locationRestTodoGet,
    RequestRouteTodoPut,
    ParamsRouteTodoPut,
    ResponseRouteTodoPut,
    locationRestTodoPut,
    RequestRouteTodoDelete,
    ParamsRouteTodoDelete,
    ResponseRouteTodoDelete,
    locationRestTodoDelete,
    RequestRouteTodoPost,
    ParamsRouteTodoPost,
    ResponseRouteTodoPost,
    locationRestTodoPost
} from "../wp-api";
import { request } from "../utils";
import type { statusType } from "../interfaces";
import { getCurrentID } from "../utils/helpers";

/* istanbul ignore next: Example implementations gets deleted the most time after plugin creation! */
class TodoStore extends BaseStore {
    @observable
    public todos: TodoModel[] = [];

    constructor(rootStore: RootStore) {
        super(rootStore);
    }

    async getTodos(params: any) {
        runInAction(() => {
            this.initAPIRequestUIStatuses(true);
        });
        try {
            const result = await request<RequestRouteTodoGet, ParamsRouteTodoGet, ResponseRouteTodoGet>({
                location: locationRestTodoGet,
                params
            });
            runInAction(() => {
                this.todos = result.data;
                this.currentPage = result.currentPage;
                this.total = result.total;
            });
        } catch (e) {
            runInAction(() => {
                this.handleException(e);
            });
        } finally {
            runInAction(() => {
                this.loading = false;
            });
        }
    }

    async addTodo(description: string, mentions: number[]) {
        runInAction(() => {
            this.initAPIRequestUIStatuses(true);
        });
        try {
            const result = await request<RequestRouteTodoPost, ParamsRouteTodoPost, ResponseRouteTodoPost>({
                location: locationRestTodoPost,
                request: {
                    description,
                    entity_id: getCurrentID(),
                    mentions
                }
            });
            runInAction(() => {
                this.todos.push(result.data[0]);
                this.errors = result.errors ? result.errors : [];
                this.errorType = result.errors ? "warning" : "success";
            });
        } catch (e) {
            runInAction(() => {
                this.handleException(e);
            });
        } finally {
            runInAction(() => {
                this.loading = false;
            });
        }
    }

    async updateTodo(todo: TodoModel, isDone: boolean) {
        runInAction(() => {
            this.initAPIRequestUIStatuses();
        });
        try {
            const result = await request<RequestRouteTodoPut, ParamsRouteTodoPut, ResponseRouteTodoPut>({
                location: locationRestTodoPut,
                params: {
                    id: todo.id
                },
                request: {
                    status: this.tranformStatus(isDone)
                }
            });
            runInAction(() => {
                const updatedTodo = result.data[0];
                const index = this.todos.indexOf(todo);
                if (index !== -1) {
                    this.todos[index] = updatedTodo;
                }
            });
        } catch (e) {
            runInAction(() => {
                this.handleException(e);
            });
        }
    }

    async deleteTodo(todo: TodoModel) {
        runInAction(() => {
            this.initAPIRequestUIStatuses();
        });
        try {
            await request<RequestRouteTodoDelete, ParamsRouteTodoDelete, ResponseRouteTodoDelete>({
                location: locationRestTodoDelete,
                params: {
                    id: todo.id
                }
            });
            runInAction(() => {
                const index = this.todos.indexOf(todo);
                if (index !== -1) {
                    this.todos.splice(index, 1);
                }
            });
        } catch (e) {
            runInAction(() => {
                this.handleException(e);
            });
        }
    }

    tranformStatus(isDone: boolean): statusType {
        if (isDone) {
            return {
                text: "Done",
                label: "done",
                isDone: true
            };
        } else {
            return {
                text: "Open",
                label: "open",
                isDone: false
            };
        }
    }
}

export { TodoStore };
